import { useCallback } from 'react';

import { useExplorationActions } from '../context/ExplorationContext';
import type { DrillLocation } from '../types/exploration';

/**
 * Drill into a location, pushing a browser history entry so canvas-out and native Back can
 * undo it. Shared by the bubble and treemap canvases, which had identical copies.
 */
export function useDrillPush() {
  const actions = useExplorationActions();
  return useCallback(
    (location: DrillLocation) => {
      actions.setDrillPath(location, { historyMode: 'push' });
    },
    [actions]
  );
}
